<meta charset="utf-8">
<fieldset class="panel">
  <div class="text-center">
    <span class="situacao">Declaração Dia - {{ marcacaoAtual.data_Comparecimento | date: 'dd/MM/yyyy' }} {{
      marcacaoAtual.isTravada ? 'Travada' : '' }}</span>
    <button class="btn btn-sm btn-primary" (click)="imprimir()">Imprimir</button>
    <button class="btn btn-sm btn-primary mr-5" (click)="copiarSolicitacao()"
      [disabled]="marcacaoAtual.status_Atendimento !== 7 && marcacaoAtual.status_Atendimento !== 6"
      title="Copia o encaminhamento deste atendimento.">
      <i class="fa fa-clipboard"></i> Copiar
    </button>
    <button class="btn btn-sm btn-primary mr-5" (click)="colarSolicitacao()"
      [disabled]="!solicitacaoCopiada || marcacaoAtual.status_Atendimento !== 5"
      title="Cola o encaminhamento copiado da última consulta FINALIZADA.">
      <i class="fa fa-paste"></i> Colar
    </button>
  </div>
  <div class="toolbar mb-2 d-flex align-items-center gap-1" title="Negrito">
    <button type="button" class="btn btn-sm btn-light" (click)="format('bold')">
      <b>N</b>
    </button>

    <button type="button" class="btn btn-sm btn-light" title="Itálico" (click)="format('italic')">
      <i>I</i>
    </button>

    <button type="button" class="btn btn-sm btn-light" title="Sublinhado" (click)="format('underline')">
      <u>S</u>
    </button>

    <!-- Cor da fonte -->
    <label class="btn btn-sm btn-light color-btn" title="Cor da Fonte">
      <i class="bi bi-palette"></i>
      <input type="color" (change)="setColor($event)" />
    </label>

    <!-- Cor de fundo -->
    <label class="btn btn-sm btn-light color-btn" title="Cor de Fundo">
      <i class="bi bi-brush-fill"></i>
      <input type="color" (change)="setBackground($event)" />
    </label>
  </div>
  <div class="container-fluid mb-2">
    <div class="row">
      <div class="col-12">
        <div class="form-control input-demarcado" [attr.contenteditable]="!marcacaoAtual.isTravada"
          [(contenteditableModel)]="marcacaoAtual.solicitacoes"></div>
      </div>
    </div>
  </div>
</fieldset>